import type { CSSProperties } from 'react';
import { ModuleData } from '../../Types/containerV2';
import {
	type DividerLineAlign,
	type DividerLineStyle,
	isDividerModuleContent,
} from '../../Types/containerV2/modules/divider';
import './DividerModule.scss';

type DividerModuleProps = {
	module: ModuleData;
};

const defaultColor = '#d0d5dd';
const defaultThickness = '1px';
const defaultLineStyle: DividerLineStyle = 'solid';
const defaultLineWidth = '100%';
const defaultLineAlign: DividerLineAlign = 'center';

const DividerModule = ({ module }: DividerModuleProps) => {
	if (!isDividerModuleContent(module.content)) {
		return null;
	}

	const content = module.content;
	const lineAlign = content.lineAlign ?? defaultLineAlign;
	const lineStyle = content.lineStyle ?? defaultLineStyle;
	const className = `biz-divider-module__line biz-divider-module__line--${lineAlign}`;
	const style = {
		'--divider-line-color': content.color || defaultColor,
		'--divider-line-thickness': content.thickness || defaultThickness,
		'--divider-line-style': lineStyle,
		'--divider-line-width': content.lineWidth || defaultLineWidth,
	} as CSSProperties;

	return (
		<div className='biz-module biz-divider-module'>
			<hr className={className} style={style} />
		</div>
	);
};

export default DividerModule;
